'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  max-width: 90%;\n  max-height: 90%;\n  background-color: white;\n  border: 1px solid #ccc;\n  img {\n    max-width: 80%;\n  }\n  @media(min-width: 450px) {\n    max-width: 400px;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  max-width: 90%;\n  max-height: 90%;\n  background-color: white;\n  border: 1px solid #ccc;\n  img {\n    max-width: 80%;\n  }\n  @media(min-width: 450px) {\n    max-width: 400px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 0.7rem;\n  text-align: center;\n  max-width: 75%;\n  padding: 1.5rem;\n  a, a:visited, a:active {\n    color: #0275d8\n  }\n'], ['\n  font-size: 0.7rem;\n  text-align: center;\n  max-width: 75%;\n  padding: 1.5rem;\n  a, a:visited, a:active {\n    color: #0275d8\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _stage = require('../stage/stage');

var _stage2 = _interopRequireDefault(_stage);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _directToShowButton = require('./direct-to-show-button');

var _directToShowButton2 = _interopRequireDefault(_directToShowButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var Panel = _styledComponents2.default.div(_templateObject2);

var Terms = _styledComponents2.default.div(_templateObject3);

var SampleClickthrough = function (_Component) {
  _inherits(SampleClickthrough, _Component);

  function SampleClickthrough(props) {
    _classCallCheck(this, SampleClickthrough);

    var _this = _possibleConstructorReturn(this, (SampleClickthrough.__proto__ || Object.getPrototypeOf(SampleClickthrough)).call(this, props));

    _this.state = {
      clicked: false
    };
    return _this;
  }

  _createClass(SampleClickthrough, [{
    key: 'render',
    value: function render() {
      if (this.state.clicked) {
        return this.props.children;
      } else {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_stage2.default, this.props.stage),
          _react2.default.createElement(
            Wrapper,
            null,
            _react2.default.createElement(
              Panel,
              null,
              _react2.default.createElement('img', { src: this.props.logo }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_directToShowButton2.default, null)
              ),
              _react2.default.createElement(
                Terms,
                null,
                'See our',
                _react2.default.createElement(
                  _reactRouterDom.Link,
                  { to: '/privacy' },
                  ' Privacy Policy '
                ),
                ' and',
                _react2.default.createElement(
                  _reactRouterDom.Link,
                  { to: '/tos' },
                  ' Terms of Service '
                ),
                '.'
              )
            )
          )
        );
      }
    }
  }]);

  return SampleClickthrough;
}(_react.Component);

exports.default = SampleClickthrough;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/auth/simple-entry.js
// module id = 1195
// module chunks = 0